/* eslint-disable @wix/da/import-scss-last */
import 'react-hot-loader/patch';
import { getClientInstance } from '@wix/da-ddt';
import i18n from '@wix/da-i18next/pkg/presetI18nClientConfig';
// project-base needs to go before app styles
import '@wix/da-ds/src/styles/project-base.scss';
import DreamupApp from './components/dreamup/DreamupApp';
import { configureStore } from './redux/dreamup/configureStore';
import { configureHistoryListener } from '@wix/da-shared-react/pkg/redux/routing/history';
import { hydrateRoot } from 'react-dom/client';
import { getEnv } from '@wix/da-react-app/pkg/client/Environment/redux/selectors';
import AppDocumentWrapper from '@wix/da-react-app/pkg/client/AppDocumentWrapper';
import Modal from 'react-modal';
import {
  forceDarkThemeSelector,
  forceDarkThemeSkinSelector,
} from './redux/dreamup/selectors';

import { MuroDepContext } from '@wix/da-react-context/pkg/MuroDepContext';
import MicroMuro from '@wix/da-muro-ui/pkg/components/MuroEditor/preset/Micro';
import MiniMuro from '@wix/da-muro-ui/pkg/components/MuroEditor/preset/Mini';
import MobileMuro from '@wix/da-muro-ui/pkg/components/MuroEditor/preset/Mobile';

const MuroDepValue = {
  MicroComponent: MicroMuro,
  MiniComponent: MiniMuro,
  MobileComponent: MobileMuro,
};

const ddt = getClientInstance();
ddt.replayServerSideLogs(window['__DDT__']);

const initialI18n = window['__INITIAL_I18N__'];

const initialState = window['__INITIAL_STATE__'];
delete window['__INITIAL_STATE__'];

const store = configureStore(initialState);
configureHistoryListener(store);

i18n(
  initialI18n,
  getEnv(store.getState()).isDebug,
  getEnv(store.getState()).flags
);
Modal.setAppElement('body');
hydrateRoot(
  document,
  <MuroDepContext.Provider value={MuroDepValue}>
    <AppDocumentWrapper
      store={store}
      themeSelector={forceDarkThemeSelector}
      themeSkinSelector={forceDarkThemeSkinSelector}
    >
      <DreamupApp language={initialI18n.locale} />
    </AppDocumentWrapper>
  </MuroDepContext.Provider>
);
